import {fabric} from 'fabric';
import {AbstractShapeFactory} from './AbstractShapeFactory';
import {WBUtils} from '../util/WBUtils';

export class ScreenPhoneFactory extends AbstractShapeFactory {

  constructor() {
    super();
    this.awType = 'phone';
    this.parentButton = WBUtils.buttonAdvanced;
  }

  /**
     * Creates and returns a fabric path object at position (anchorX/anchorY) and sets
     * the attriubtes color, fill and stroke
     */
  public create(anchorX: number, anchorY: number, color: string, fill: string, stroke: number): any {
    let phonePath = 'M25.302,0H9.698c-1.3,0-2.364,1.063-2.364,2.364v30.271C7.334,33.936,8.398,35,9.698,35h15.604 ';
    phonePath += 'c1.3,0,2.364-1.062,2.364-2.364V2.364C27.666,1.063,26.602,0,25.302,0z M15.004,1.704h4.992c0.158,0,0.286,0.128,';
    phonePath += '0.286,0.287 c0,0.158-0.128,0.286-0.286,0.286h-4.992c-0.158,0-0.286-0.128-0.286-0.286C14.718,1.832,14.846,';
    phonePath += '1.704,15.004,1.704z M17.5,33.818 c-0.653,0-1.182-0.529-1.182-1.183s0.529-1.182,1.182-1.182s1.182,0.528,1.182,';
    phonePath += '1.182S18.153,33.818,17.5,33.818z M26.021,30.625 H8.979V3.749h17.042V30.625z ';

    this.shapeObject = new fabric.Path(phonePath);
    this.shapeObject.set({
      left: anchorX,
      top: anchorY,
      fill: 'rgba(0,0,0,0)',
      stroke: color,
      strokeWidth: stroke / 30
    });
    this.shapeObject.scaleToWidth(5);

    return this.shapeObject;
  }

  /**
     * modifies the path object expanding it to position (eventX/eventY), also checks
     * the direction of movement with position (anchorX, anchorY).
     */
  public modify(anchorX: number, anchorY: number, eventX: number, eventY: number) {
    if (anchorX > eventX) {
      this.shapeObject.set({
        left: Math.abs(eventX)
      });
    }
    if (anchorY > eventY) {
      this.shapeObject.set({
        top: Math.abs(eventY)
      });
    }

    this.shapeObject.scaleToWidth(Math.abs(anchorX - eventX));
    this.shapeObject.setCoords();
  }

  /**
     * Executes the copy method of the AbstractShapeFactory
     */
  public copyAndDrop(id: number, awtype: string, callback: (clone) => void) {
    this.copy(id, awtype, callback);
  }

}
